import { Card, Image, makeStyles, Text } from "@fluentui/react-components";
import { Checkmark16Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    contentWrapper: {
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        width: '100%',
        minHeight: '600px',
        padding: '4rem 1rem',
        boxSizing: 'border-box',
        flexDirection: 'column-reverse',
        
        '@media(min-width: 768px)': {
            flexDirection: 'row',
            padding: '4rem 0'
        },
    },
    innerContainer: {
        position: "relative",
        display: 'flex',
        justifyContent: 'flex-end',
        maxWidth: '1200px',
        width: '100%',
        padding: '0 1rem',
        boxSizing: 'border-box',
        flexDirection: 'column',
        
        '@media(min-width: 768px)': {
            flexDirection: 'row',
            padding: '0 4rem'
        },
    },
    imgCard: {
        position: "relative",
        width: "100%",
        height: "300px",
        overflow: "hidden",
        borderRadius: "16px",
        marginBottom: "2rem",

        "@media(min-width: 768px)": {
            position: "absolute",
            left: "1rem",
            width: "75%",
            height: "500px",
            marginBottom: "0"
        },
        
        "& img": {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "opacity 500ms"
        }
    },
    overlay: {
        position: "absolute",
        inset: 0,
        backgroundColor: "rgba(0, 0, 0, 0.4)"
    },
    badge: {
        display: "inline-block",
        padding: "0.4rem 0.8rem",
        backgroundColor: "var(--colorBrandBackground2)",
        color: "var(--colorBrandForeground2)",
        borderRadius: "20px",
        fontSize: "12px",
        fontWeight: "var(--fontWeightSemibold)",
        textTransform: "uppercase",
        letterSpacing: "0.5px"
    },
    contentCard: {
        position: "relative",
        zIndex: "10",
        width: "100%",
        backgroundColor: "var(--colorNeutralBackground1)",
        padding: "2.5rem",
        borderRadius: "16px",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
        marginTop: "-3rem",
        "@media(min-width: 768px)": {
            width: "40%",
            marginLeft: "-15%",
            marginTop: "2rem"
        },
    },
    details: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        marginTop: "1rem"
    },
    detail: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
    },
    checkIcon: {
        color: 'var(--colorBrandForeground1)',
        fontWeight: 'bold',
        fontSize: '16px',
        width: '16px',
        minWidth: '16px',
        maxWidth: '16px',
    }
});

const Detail = (props: { service: string }) => {
    const { service } = props;
    const styles = useStyles();

    return (
        <div className={styles.detail}>
            <Checkmark16Regular className={styles.checkIcon} />
            <Text>{service}</Text>
        </div>
    );
};

export default function PromotedImage() {
    const styles = useStyles();
    const { t } = useTranslation("helpdesk");
    const details = t("promotedImage.details", { returnObjects: true, defaultValue: [] }) as string[];

    return (
        <div className={styles.contentWrapper}>
            <div className={styles.innerContainer}>
                <div className={styles.imgCard}>
                    <Image
                        src={t("promotedImage.image.src")}
                        alt={t("promotedImage.image.altText")}
                    />
                    <div className={styles.overlay} />
                </div>
                <Card className={styles.contentCard}>
                    <div>
                        {
                            t("promotedImage.title") &&
                            <Text as="span" className={styles.badge}>
                                {t("promotedImage.header")}
                            </Text>
                        }
                        <Text block as="h3" size={700} weight="semibold">
                            {t("promotedImage.title")}
                        </Text>
                        <Text as="p" size={300}>
                            {t("promotedImage.description")}
                        </Text>
                        <div className={styles.details}>
                            {details.map((detail, index) => (
                                <Detail key={index} service={detail} />
                            ))}
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    );
}